<template>
  <div>
    <div>
      <el-button
          type="primary"
          plain
          icon="el-icon-plus"
          size="mini"
          @click="add">
        新增
      </el-button>
    </div>
    <el-table style="width: 100%" :data="tableData">
      <el-table-column
          prop="bannerName"
          align="center"
          label="文章标题"
          width="460px">
      </el-table-column>
      <el-table-column
          prop="fileUrl"
          align="center"
          label="文件地址"
          width="460px">
      </el-table-column>
      <el-table-column
          prop="fileUrl"
          align="center"
          label="是否展示"
          width="160px">
        <template slot-scope="row">
          <span>{{row.showFlag?'否':'是'}}</span>
        </template>
      </el-table-column>
      <el-table-column
          label="操作"
          align="center"
          width="440px"
          class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <el-button
              size="mini"
              type="text"
              icon="el-icon-edit"
              @click="handleUpdate(scope.row)"
          >修改</el-button>
          <el-button
              size="mini"
              type="text"
              icon="el-icon-edit"
              @click="handleDel(scope.row)"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
        background
        style="text-align: center"
        layout="prev, pager, next"
        :total="total"
        :current-page="queryParams.pageNum"
        :page-size="queryParams.pageSize"
        @current-change="handleCurrentChange">
    </el-pagination>
    <el-dialog :title="title" :visible.sync="open" width="40%">
      <el-form ref="form" :model="banner">
        <el-row>
          <el-col :span="24">
            <el-form-item prop="bannerName" label="荣誉名称:" label-width="120px">
              <el-input v-model="banner.bannerName" type="text">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="showFlag" label="是否展示：" label-width="120px">
              <el-switch
                  v-model="banner.showFlag"
                  active-color="#13ce66"
                  inactive-color="#ff4949">
              </el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="sort" label="展示排序：" label-width="120px">
              <el-input type="number" v-model="banner.sort">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div>
        <el-row>
          <el-col :span="6">

            <el-upload
                class="avatar-uploader"
                :show-file-list="false"
                :headers="uploadHeaders"
                :action="fileUrl"
                :on-success="handleAvatarSuccess">
              <img v-if="banner.fileUrl" :src="banner.fileUrl" class="avatar">
             <el-button v-if="!banner.fileUrl">上传图片</el-button>
              <!--        <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>-->
            </el-upload>
          </el-col>
        </el-row>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm" >提 交</el-button>
        <el-button @click="cancel">关 闭</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import {Message} from "element-ui";
import {addBanner, delBanner, getBannerList, updateBanner} from "@/api/admin";
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "honor",
  data(){
    return{
      tableData:undefined,
      total:0,
      totalElements:0,
      queryParams: {
        pageNum: 1,
        pageSize: 10,
      },
      open:false,
      uploadHeaders: {
        Authorization: sessionStorage.getItem('token')// 假设token存储在Vuex中
      },
      fileUrl: process.env.VUE_APP_BASE_API+ "/file/upload",
      banner:{
        id:undefined,//	id:		false
        bannerName:undefined,//		banner名称:		true
        fileUrl:undefined,//	文件地址不能为空:		false
        showFlag:true,//	是否展示:		true
        sort:undefined,//
      },
      title:undefined,
    }
  },
  mounted() {
    this.getList()
  },
  methods:{
    handleDel(row){
      delBanner([row.id]).then(()=>{
        this.$message({
          type: 'success',
          message: '删除成功!'
        });
        this.getList()
      })
    },
    handleUpdate(row){
      this.banner={
        id:undefined,//	id:		false
        bannerName:undefined,//		banner名称:		true
        fileUrl:undefined,//	文件地址不能为空:		false
        showFlag:true,//	是否展示:		true
        sort:undefined,//
      }
      this.open=true
      this.title='修改荣誉'
      let data=JSON.stringify(row)
      this.banner=JSON.parse(data)
    },
    handleCurrentChange(pageNum){
      this.queryParams.pageNum=pageNum
      this.getList()
    },
    getList(){
      getBannerList(this.queryParams).then(async res=>{
        const data=await  res.data
        this.tableData= data.content
        this.total=data.totalElements
      })
    },
    handleAvatarSuccess(res) {
      if(res.code==403){
        Message.error('登录过期，请重新登录')
        setTimeout(() => {
          location.href = '/admin/login';
        })
      }
      this.banner.fileUrl = res.data;
    },
    add(){
      // this.clear()
      this.banner={
        id:undefined,//	id:		false
            bannerName:undefined,//		banner名称:		true
            fileUrl:undefined,//	文件地址不能为空:		false
            showFlag:true,//	是否展示:		true
            sort:undefined,//
      }
      this.open=true
      this.title="新增荣誉"
    },
    submitForm(){
      if(this.title.includes('新增')){
        addBanner(this.banner).then((res)=>{
          if (res.code==200){
            this.open=false
            Message.success('新增成功')
            this.getList()
          }
        })
      }else {
        updateBanner(this.banner).then((res)=>{
          if (res.code==200){
            this.open=false
            Message.success('修改成功')
            this.getList()
          }
        })
      }
    },

    cancel(){
        this.open=false
    },
  }
}
</script>

<style scoped>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
